/* eslint-disable max-len */
export const Target: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="stroke-icon"
    {...props}
  >
    <path
      d="M11.1667 5.83325V3.83325L13.1667 1.83325L13.8333 3.16659L15.1667 3.83325L13.1667 5.83325H11.1667ZM11.1667 5.83325L8.50002 8.49988M15.1667 8.49992C15.1667 12.1818 12.1819 15.1666 8.50004 15.1666C4.81814 15.1666 1.83337 12.1818 1.83337 8.49992C1.83337 4.81802 4.81814 1.83325 8.50004 1.83325M11.8334 8.49992C11.8334 10.3409 10.341 11.8333 8.50004 11.8333C6.65909 11.8333 5.16671 10.3409 5.16671 8.49992C5.16671 6.65897 6.65909 5.16659 8.50004 5.16659"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
